import { Container, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { GameFont } from "../GameFont";
import { PiggyIcon } from "./PiggyIcon";

export class PiggyClubMultiplier extends Container {
    private readonly roundedRectangle: Sprite;
    private readonly piggyIcon: PiggyIcon;
    private readonly tokenIcon: Sprite;
    private readonly multiplierText: Text;

    public constructor(commonResources: CommonResourcesPackage, piggyTexture: Texture, multiplierValue?: string) {
        super();
        this.roundedRectangle = new Sprite(commonResources.assets_common_ui_piggy_club_multiplier_bg_png);
        this.roundedRectangle.position.set(0, 6);
        this.piggyIcon = new PiggyIcon(piggyTexture ?? Texture.EMPTY);
        this.piggyIcon.y = 5;
        this.multiplierText = new Text(`${multiplierValue ?? '0%'}`, new MultiplierTextStyle());
        this.multiplierText.position.set(this.piggyIcon.x + this.piggyIcon.width + 15, this.piggyIcon.height * 0.5 - this.multiplierText.height * 0.5);
        this.tokenIcon = new Sprite(commonResources.assets_common_ui_button_token_icon_png);
        this.tokenIcon.scale.set(0.9);
        this.tokenIcon.position.set(this.multiplierText.x + this.multiplierText.width + 15, this.multiplierText.y + this.multiplierText.height * 0.5 - this.tokenIcon.height * 0.5);

        this.addChild(
            this.roundedRectangle,
            this.piggyIcon,
            this.multiplierText,
            this.tokenIcon
        );
    }
}

class MultiplierTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 34,
            fill: 'FFFFFF'
        });
    }
}
